import React from "react";

import Icon from "../icon/Icon";
import { IconName } from "../icon/src/helper";
import { StyleSize } from "../../common/models";

type ButtonMode = "primary" | "ghost" | "link";
// | "success" | "danger";

interface Props {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  label?: string;
  mode?: ButtonMode;
  icon?: IconName;
  className?: string;
  type?: "submit" | "reset" | "button";
  loading?: boolean;
  size?: StyleSize;
  disabled?: boolean;
}

const Button: React.FC<Props> = ({
  className,
  icon,
  label,
  loading,
  mode,
  onClick,
  disabled,
  size = "default",
  type = "button",
}): React.ReactElement => {
  const iconSizeClass = {
    small: "sm:w-[16px] sm:h-[16px]",
    default: "sm:w-[24px] sm:h-[24px]",
    big: "sm:w-[24px] sm:h-[24px]",
    extra: "sm:w-[32px] sm:h-[32px]",
  };

  return (
    <button
      type={type}
      className={`${mode} ${size} ${disabled ? "disabled" : ""} ${className ?? ""}`}
      onClick={onClick}
      disabled={disabled}
    >
      {label ?? ""}
      {loading ? (
        <Icon
          className={`ml-2 animate-spin ${iconSizeClass[size]}`}
          name="loading"
          size={size}
        />
      ) : (
        icon && (
          <Icon
            className={`${label ? "ml-2" : "ml-0"} ${iconSizeClass[size]}`}
            name={icon}
            size={size}
          />
        )
      )}
    </button>
  );
};

export default Button;
